/** @jsx jsx */

import { jsx } from '@emotion/core';

import Styles from './TierGraph.styles';

const ProgressLine = ({ isCompleted, index }) => (
  <div css={[Styles.progress(isCompleted), Styles.progressBar(index)]} />
);

export default ProgressLine;
